import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ShowTableCustomer } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../components";
import { Container, Form, Row, Col, Card } from "react-bootstrap";
import { Box, Pagination, Button, ButtonGroup } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useDownloadExcel } from "react-export-table-to-excel";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilCustomer = () => {
  const ref = useRef(null);
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const screenSize = useScreenWidth();

  const [isFetchError, setIsFetchError] = useState(false);
  const [cif, setCif] = useState("");
  const [nikCustomer, setNikCustomer] = useState("");
  const [noKkCustomer, setNoKkCustomer] = useState("");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [namaPanggilanCustomer, setNamaPanggilanCustomer] = useState("");
  const [tempatLahirCustomer, setTempatLahirCustomer] = useState("");
  const [tanggalLahirCustomer, setTanggalLahirCustomer] = useState("");
  const [jenisKelaminCustomer, setJenisKelaminCustomer] = useState("");
  const [agamaCustomer, setAgamaCustomer] = useState("");
  const [noTeleponCustomer, setNoTeleponCustomer] = useState("");
  const [alamatCustomer, setAlamatCustomer] = useState("");
  const [alamatTTCustomer, setAlamatTTCustomer] = useState("");
  const [kodeProvinsi, setKodeProvinsi] = useState("");
  const [kodeProvinsiTT, setKodeProvinsiTT] = useState("");
  const [kodeKabupaten, setKodeKabupaten] = useState("");
  const [kodeKabupatenTT, setKodeKabupatenTT] = useState("");
  const [kodeKecamatan, setKodeKecamatan] = useState("");
  const [kodeKecamatanTT, setKodeKecamatanTT] = useState("");
  const [kodeKelurahan, setKodeKelurahan] = useState("");
  const [kodeKelurahanTT, setKodeKelurahanTT] = useState("");
  const [kodePos, setKodePos] = useState("");
  const [kodePosTT, setKodePosTT] = useState("");
  const [statusPerkawinanCustomer, setStatusPerkawinanCustomer] = useState("");
  const [pekerjaanCustomer, setPekerjaanCustomer] = useState("");
  const [kewarganegaraanCustomer, setKewarganegaraanCustomer] = useState("");

  const [namaPerusahaanCustomer, setNamaPerusahaanCustomer] = useState("");
  const [bidangUsahaCustomer, setBidangUsahaCustomer] = useState("");
  const [jabatanCustomer, setJabatanCustomer] = useState("");
  const [alamatPerusahaanCustomer, setAlamatPerusahaanCustomer] = useState("");
  const [noTeleponPerusahaanCustomer, setNoTeleponPerusahaanCustomer] =
    useState("");
  const [lamaKerjaCustomer, setLamaKerjaCustomer] = useState("");
  const [gajiPekerjaanCustomer, setGajiPekerjaanCustomer] = useState("0");
  const [pendapatanLainCustomer, setPendapatanLainCustomer] = useState("0");

  const [previewPdf, setPreviewPdf] = useState(false);
  const [previewExcel, setPreviewExcel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [customers, setCustomers] = useState([]);
  const [customersPagination, setCustomersPagination] = useState([]);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    getCustomersPagination();
    id && getCustomerById();
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [id, page, searchTerm]);

  const getCustomersPagination = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/customersPerCabangPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      setCustomersPagination(response.data.customers);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getCustomers = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/customersPerCabang`, {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });
      setCustomers(response.data);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getCustomerById = async () => {
    if (id) {
      const response = await axios.post(`${tempUrl}/customers/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setCif(response.data.cifCustomer);
      setNikCustomer(response.data.nikCustomer);
      setNoKkCustomer(response.data.noKkCustomer);
      setNamaCustomer(response.data.namaCustomer);
      setNamaPanggilanCustomer(response.data.namaPanggilanCustomer);
      setTempatLahirCustomer(response.data.tempatLahirCustomer);
      setTanggalLahirCustomer(formatDate(response.data.tanggalLahirCustomer));
      setJenisKelaminCustomer(response.data.jenisKelaminCustomer);
      setAgamaCustomer(response.data.agamaCustomer);
      setNoTeleponCustomer(response.data.noTeleponCustomer);
      setAlamatCustomer(response.data.alamatCustomer);
      setAlamatTTCustomer(response.data.alamatTTCustomer);
      setKodeProvinsi(response.data.provinsis.namaProvinsi);
      setKodeProvinsiTT(response.data.provinsisTT.namaProvinsi);
      setKodeKabupaten(response.data.kabupaten.namaKabupaten);
      setKodeKabupatenTT(response.data.kabupatenTT.namaKabupaten);
      setKodeKecamatan(response.data.kecamatan.namaKecamatan);
      setKodeKecamatanTT(response.data.kecamatanTT.namaKecamatan);
      setKodeKelurahan(response.data.kelurahan.namaKelurahan);
      setKodeKelurahanTT(response.data.kelurahanTT.namaKelurahan);
      setKodePos(response.data.kelurahan.kodePos);
      setKodePosTT(response.data.kelurahanTT.kodePos);
      setStatusPerkawinanCustomer(response.data.statusPerkawinanCustomer);
      setPekerjaanCustomer(response.data.pekerjaanCustomer);
      setKewarganegaraanCustomer(response.data.kewarganegaraanCustomer);

      setNamaPerusahaanCustomer(response.data.namaPerusahaanCustomer);
      setBidangUsahaCustomer(response.data.bidangUsahaCustomer);
      setJabatanCustomer(response.data.jabatanCustomer);
      setAlamatPerusahaanCustomer(response.data.alamatPerusahaanCustomer);
      setNoTeleponPerusahaanCustomer(response.data.noTeleponPerusahaanCustomer);
      setLamaKerjaCustomer(response.data.lamaKerjaCustomer);
      setGajiPekerjaanCustomer(response.data.gajiPekerjaanCustomer);
      setPendapatanLainCustomer(response.data.pendapatanLainCustomer);
    }
  };

  const deleteCustomer = async (id) => {
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deleteCustomer/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setSearchTerm("");
      setNikCustomer("");
      setNoKkCustomer("");
      setCif("");
      setNamaCustomer("");
      setNamaPanggilanCustomer("");
      setTempatLahirCustomer("");
      setTanggalLahirCustomer("");
      setJenisKelaminCustomer("");
      setAgamaCustomer("");
      setNoTeleponCustomer("");
      setAlamatCustomer("");
      setKodeProvinsi("");
      setKodeKabupaten("");
      setKodeKecamatan("");
      setKodeKelurahan("");
      setKodePos("");
      setStatusPerkawinanCustomer("");
      setPekerjaanCustomer("");
      setKewarganegaraanCustomer("");

      setNamaPerusahaanCustomer("");
      setBidangUsahaCustomer("");
      setJabatanCustomer("");
      setAlamatPerusahaanCustomer("");
      setNoTeleponPerusahaanCustomer("");
      setLamaKerjaCustomer("");
      setGajiPekerjaanCustomer("0");
      setPendapatanLainCustomer("0");
      navigate("/customer");
    } catch (error) {
      if (error.response.data.message.includes("foreign key")) {
        alert(`${cif} tidak bisa dihapus karena sudah ada data!`);
      }
    }
    setLoading(false);
  };

  const downloadPdf = () => {
    var date = new Date();
    var current_date = formatDate(date);
    var current_time =
      date.getHours().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getMinutes().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getSeconds().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    const doc = new jsPDF();
    doc.setFontSize(10);
    doc.text(
      `${setting.namaPerusahaan} - ${setting.kabupatenPerusahaan}`,
      15,
      10
    );
    doc.text(`${setting.alamatPerusahaan}`, 15, 15);
    doc.setFontSize(14);
    doc.text(`Daftar Customer`, 85, 30);
    doc.setFontSize(8);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.autoTable({
      html: "#table",
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
      styles: {
        fontSize: 8,
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Customer",
    sheet: "daftarCustomer",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container ref={ref}>
      <h3>Master</h3>
      <h5 style={{ fontWeight: 400 }}>Daftar Customer</h5>
      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getCustomers();
              setPreviewPdf(!previewPdf);
              setPreviewExcel(false);
            }}
          >
            PDF
          </Button>
          <Button
            color="secondary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getCustomers();
              setPreviewExcel(!previewExcel);
              setPreviewPdf(false);
            }}
          >
            Excel
          </Button>
        </ButtonGroup>
      </Box>
      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={() => downloadPdf()}
          >
            CETAK
          </Button>
          <table class="table" id="table">
            <thead>
              <tr>
                <th>Nama</th>
                <th>Alamat</th>
                <th>No. Telp</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.namaCustomer}</td>
                  <td>{user.alamatCustomer}</td>
                  <td>{user.noTeleponCustomer}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div>
        {previewExcel && (
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        )}
        <table ref={tableRef}>
          {previewExcel && (
            <tbody>
              <tr>
                <th>Nama</th>
                <th>Alamat</th>
                <th>No. Telp</th>
              </tr>
              {customers.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.namaCustomer}</td>
                  <td>{user.alamatCustomer}</td>
                  <td>{user.noTeleponCustomer}</td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={id}
          kode={id}
          addLink={`/customer/tambahCustomer`}
          editLink={`/customer/${id}/edit`}
          deleteUser={deleteCustomer}
          nameUser={cif}
        />
      </Box>
      {id && (
        <Container>
          <hr />
          <Form>
            {/* Customer */}
            <Card>
              <Card.Header>Customer</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            CIF :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control value={cif} disabled readOnly />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            NIK :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={nikCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. KK :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={noKkCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={namaCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama Panggilan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={namaPanggilanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tempat Lahir :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={tempatLahirCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tgl. Lahir :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={tanggalLahirCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Jenis Kelamin :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={jenisKelaminCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Agama :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={agamaCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. Telp / HP :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={noTeleponCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Status Perkawinan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={statusPerkawinanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Pekerjaan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={pekerjaanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kewarganegaraan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kewarganegaraanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Alamat (Identitas) */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Alamat (Identitas)</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={alamatCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKelurahan}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKecamatan}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKabupaten}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeProvinsi}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control value={kodePos} disabled readOnly />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Tempat Tinggal */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Tempat Tinggal</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={alamatTTCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKelurahanTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKecamatanTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKabupatenTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeProvinsiTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control value={kodePosTT} disabled readOnly />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Pekerjaan */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Data Pekerjaan</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama Perusahaan / Usaha :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={namaPerusahaanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Bidang Usaha :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={bidangUsahaCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Jabatan / Posisi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={jabatanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat Perusahaan / Usaha :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={alamatPerusahaanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No .Telp Perusahaan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={noTeleponPerusahaanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Lama Kerja / Status :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={lamaKerjaCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Besaran Gaji / Bulan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={gajiPekerjaanCustomer.toLocaleString(
                                "de-DE"
                              )}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Pendapatan Lain :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={pendapatanLainCustomer.toLocaleString(
                                "de-DE"
                              )}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>
          </Form>
        </Container>
      )}
      <hr />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableCustomer currentPosts={customersPagination} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Container>
  );
};

export default TampilCustomer;

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};
